import update from 'immutability-helper';
import { createReducer } from '../utils/reducers';
import { SET_SHIPPING_PROFILE_WHITELIST } from '../actions/shipping';

import { SET_CATEGORIES, SET_CATEGORIES_LOADING } from '../actions/product';
import {SET_SHIPPING_USER_WHITELIST,SET_SHIPPING_AUTOCONFIG,SET_SHIPPING_SETTINGS_LOADING,TOGGLE_HTTP_ERROR_ALERT,SUCCESS_TOAST,SHOULD_LOADING,SET_DOMESTIC_INTERNATIONAL_SHIPPING_SERVICES,SET_NOTIFICATIONS} from '../actions/shipping'


export const initialState = {
  sites: {},
  showcases: {},
  categories: [],
  categoriesLoading: false,
  defaults: {},
  currencies: [],
  regions: {},
  config: "UNSET",
  shippingSettingsLoading: false,
  shippingProfileWhiteList:"UNSET",
  shippingProfileWhiteListIsBeingFetched: false,
  shippingHttpErrorAlertOpenStatus: false, 
  shippingHttpErrorMsg: "",
  shippingSuccessToastStatus: false,
  shouldLoading: false,
  domesticShippingServices:[],
  internationalServices:[],
  notifications:[]
};

export default createReducer(
  {
    [SET_CATEGORIES]: (state, { data = [] }) =>
      update(state, {
        categories: { $set: data },
      }),
    [SET_CATEGORIES_LOADING]: (state, { loading }) =>
      update(state, {
        categoriesLoading: {
          $set: loading,
        },
      }),
       // handle shippingProfileWhiteList 
    [SET_SHIPPING_USER_WHITELIST]: (state, {shippingProfileWhiteList}) =>{
      return update(state, {
        shippingProfileWhiteList: { $set: shippingProfileWhiteList }
      })
    },
   
    [SET_DOMESTIC_INTERNATIONAL_SHIPPING_SERVICES]: (state, {domesticShippingServices,internationalServices}) =>{
      return update(state, {
        domesticShippingServices: { $set: domesticShippingServices },
        internationalServices: { $set: internationalServices },
      })
    },
    // handle SET_SHIPPING_AUTOCONFIG 
    [SET_SHIPPING_AUTOCONFIG]: (state, {config}) =>{
    return update(state, {
      config: { $set: config },
      })
    },
    // handle SET_SHIPPING_SETTINGS_LOADING 
    [SET_SHIPPING_SETTINGS_LOADING]: (state, {shippingSettingsLoading}) =>{
      console.log("🚀 ~ file: global.js:48 ~ shippingSettingsLoading:", shippingSettingsLoading)
      return update(state, {
        shippingSettingsLoading: { $set: shippingSettingsLoading },
        })
    },
    // handle TOGGLE_HTTP_ERROR_ALERT 
    [TOGGLE_HTTP_ERROR_ALERT]: (state, {shippingHttpErrorAlertOpenStatus,shippingHttpErrorMsg}) =>{
      return update(state, {
        shippingHttpErrorAlertOpenStatus: { $set: shippingHttpErrorAlertOpenStatus },
        shippingHttpErrorMsg: { $set: shippingHttpErrorMsg },
        })
    },
     // handle SUCCESS_TOAST
     [SUCCESS_TOAST]: (state, {shippingSuccessToastStatus}) =>{
      return update(state, {
        shippingSuccessToastStatus: { $set: shippingSuccessToastStatus }
        })
    },
     // handle SHOULD_LOADING
     [SHOULD_LOADING]: (state, {shouldLoading}) =>{
      return update(state, {
        shouldLoading: { $set: shouldLoading }
        })
    },
      // handle SET_NOTIFICATIONS
      [SET_NOTIFICATIONS]: (state, {notifications}) =>{
        return update(state, {
          notifications: { $set: notifications }
          })
      },
  },
  initialState
);
